import { WalletType } from '../../../shared/enums/wallet-type.enum';

export class WalletCreateDto {
	beneficiaryId: string;
	benefitId: string | null;
	isHealth: boolean;
	isNotApplicable: boolean;
	isTeeth: boolean;
	type: WalletType;
	updatedInInsuranceAt: string | null;

	walletNumber: string | null;

	constructor({
		beneficiaryId,
		benefitId,
		isHealth,
		isNotApplicable,
		isTeeth,
		type,
		updatedInInsuranceAt,
		walletNumber,
	}: WalletCreateDto) {
		this.beneficiaryId = beneficiaryId;
		this.benefitId = benefitId;
		this.isHealth = isHealth;
		this.isNotApplicable = isNotApplicable;
		this.isTeeth = isTeeth;
		this.updatedInInsuranceAt = updatedInInsuranceAt;
		this.walletNumber = walletNumber;
		this.type = type;
	}
}
